import { profile, axiosConfig } from 'api';

import { Response } from 'models/response';

export interface Alliance {
  id: string;
  name: string;
  logo: string;
  color: string;
  allianceName: string;
  program: string;
  type: string;
}

interface AllAlliancesResponse {
  data: Alliance[];
}

export interface Loyalty {
  id?: string;
  userId: string;
  loyaltyId: string;
  loyaltyName: string;
  loyaltyNumber: string;
  type: string;
  allianceName: string;
  program: string;
  logo: string;
  color: string;
  useLoyaltyNumberIfSameAlliance: boolean;
}

export const fetchGetAllAlliances = async (): Promise<Alliance[]> => {
  try {
    const response = await profile.get<AllAlliancesResponse>('users/getAllAlliances', axiosConfig);
    return response.data.data;
  } catch (error) {
    return error.data;
  }
};

export const createLoyalty = async (loyalty: Loyalty): Promise<Response<any>> => {
  try {
    console.log('createLoyalty', loyalty);
    const response = await profile.post<Response<any>>('userLoyalty', loyalty, axiosConfig);
    return response.data;
  } catch (error) {
    return error.data;
  }
};

export const updateLoyalty = async (loyalty: Loyalty): Promise<Response<any>> => {
  try {
    console.log('updateLoyalty', loyalty);
    const response = await profile.put<Response<any>>(`userLoyalty/${loyalty.id}`, loyalty, axiosConfig);
    return response.data;
  } catch (error) {
    return error.data;
  }
};

export const deleteLoyalty = async (loyaltyId: string): Promise<Response<any>> => {
  try {
    const response = await profile.delete<Response<any>>(`userLoyalty/${loyaltyId}`, axiosConfig);
    return response.data;
  } catch (error) {
    return error.data;
  }
};

export const getAllLoyaltyByUser = async (userId: string): Promise<Loyalty[]> => {
  try {
    const response = await profile.get<Response<Loyalty[]>>(
      'userLoyalty/getUserLoyaltyByUserId?id=' + userId,
      axiosConfig,
    );
    return response.data.data;
  } catch (error) {
    return error.data;
  }
};
